import { render, staticRenderFns } from "./ExamplesNavigation.vue?vue&type=template&id=bf0b984e&scoped=true"
import script from "./ExamplesNavigation.vue?vue&type=script&lang=js"
export * from "./ExamplesNavigation.vue?vue&type=script&lang=js"
import style0 from "./ExamplesNavigation.vue?vue&type=style&index=0&id=bf0b984e&prod&scoped=true&lang=css"
import style1 from "./ExamplesNavigation.vue?vue&type=style&index=1&id=bf0b984e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0b984e",
  null
  
)

export default component.exports